import { ReasonFilterRequest, ReasonRequest } from '@/main/models/request';

export enum ReasonTypes {
  GET_REASON = '@reason/GET_REASON',
  SAVE_REASON = '@reson/SAVE_REASON',
  RESET_REDUCER_REASON = '@reason/RESET_REDUCER_REASON'
}

export interface ReasonState {
  readonly reason: {
    data: ReasonRequest[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetReason {
  type: typeof ReasonTypes.GET_REASON;
  payload: {
    request: ReasonFilterRequest;
  };
}

export interface SaveReason {
  type: typeof ReasonTypes.SAVE_REASON;
  payload: {
    data: ReasonRequest[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerReason {
  type: typeof ReasonTypes.RESET_REDUCER_REASON;
}

export type ReasonActionTypes =
  | GetReason
  | SaveReason
  | ResetReducerReason;
